/**
 * The part of a plan's game chain (its storyline - backend plan.chain_games) that can be played now: its games that are
 * painted, in order. A game being rebuilt is skipped; the link into the next playable game is the one that led into it.
 */
export function playableChain(plan) {
  const story = plan.storyline;
  if (!story) return null;
  const missions = story.missions.filter((id) => plan.status?.[id]?.game);
  if (!missions.length) return null;
  const links = missions.slice(1).map((id) => story.links[story.missions.indexOf(id) - 1]);
  return { missions, links };
}
